// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tabs___2egwS","tab":"tab___Gmv8x","box":"box___2Jdqp","title":"title___3Ylgg","avtive":"avtive___2vshS"};